const Apoio = () => {
  return (
    <section className="bg-gray-50 py-16 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">APOIO</h2>
        </div>
        
        <div className="flex flex-col md:flex-row items-center justify-center gap-16">
          {/* Logo FINEP */}
          <div className="flex flex-col items-center">
            <div className="w-44 h-28 flex items-center justify-center">
              <img 
                src="/images/finep-logo.png" 
                alt="Logo FINEP" 
                className="max-w-full max-h-full object-contain"
              />
            </div>
          </div>

          {/* Logo FUNCAP */}
          <div className="flex flex-col items-center">
            <div className="w-44 h-28 flex items-center justify-center">
              <img 
                src="/images/funcap-logo.png" 
                alt="Logo FUNCAP" 
                className="max-w-full max-h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Apoio
